(function linkComponentToGroupForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LinkComponentToGroup',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('#linkcomponenttogroup-group_id').on('change', toggleNewGroupFields);
		$('#linkcomponenttogroup-group_id').trigger('change');
	};

	function toggleNewGroupFields()
	{
		var group_id = $(this).val();

		if (group_id === 'new') {
			$('.group-warning').removeClass('hidden');
			$('.new-group-row').removeClass('hidden');
			$('.amex-group-warning').addClass('hidden');
			$('.new-amex-group-row').addClass('hidden');
		} else if (group_id === 'new_amex') {
			$('.amex-group-warning').removeClass('hidden');
			$('.new-amex-group-row').removeClass('hidden');
			$('.group-warning').addClass('hidden');
			$('.new-group-row').addClass('hidden');
		} else {
			$('.amex-group-warning').addClass('hidden');
			$('.new-amex-group-row').addClass('hidden');
			$('.new-group-row').addClass('hidden');

			if (group_id === '') {
				$('.group-warning').addClass('hidden');
			} else {
				$('.group-warning').removeClass('hidden');
			}
		}
	}
}(jQuery, window.Adzuki || {}));
